import { useEffect, useRef, useState } from "react";

export function isTokenExpired(token) {
  if (!token) return true;

  const payload = JSON.parse(atob(token.split(".")[1])); // Decode token
  return payload.exp * 1000 < Date.now(); // Check if expired
}

export function useInViewClass({ threshold = 0.6, root = null, rootMargin = "0px", deadZonePx = 40 } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold, root, rootMargin }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [threshold, root, rootMargin]);

  return { ref, inView };
}